import React from "react"

class ThemeHeaderComponent extends React.Component {

	render() {
		return (
			<div className={"custom-header-cell " + (this.props.row.isSubTheme ? "sub" : "") + "theme"}>
				{this.props.row.title}
				<div className="actions">
					<button onClick={this._handleToggleThemeClick.bind(this)} title={(this.props.row.isShown ? "Masquer" : "Afficher") + " la thématique"}><i className={"fa fa-chevron-" + (this.props.row.isShown ? "up" : "down")} /></button>
				</div>
			</div>
		)
	}

	_handleToggleThemeClick() {
		this.props.onToggleTheme(this.props.row.item)
	}

}

export default ThemeHeaderComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/grants/theme-header-component.js